module.exports = __webpack_public_path__ + "img/xlsx_logo.84f462b1.svg";